// extracted by mini-css-extract-plugin
export default {"editorCard":"PropertyTemplateEditor_editorCard__EEkEJ","emptyState":"PropertyTemplateEditor_emptyState__0C2tU","form":"PropertyTemplateEditor_form__X21jf"};